import React from "react";
import Table from "../list/Table";
import { Link } from "react-router-dom";
import { IoMdPersonAdd, IoMdAdd } from "react-icons/io";
import { useTranslation } from "react-i18next";
import objectPath from "object-path";
import { API_ROOT } from "../defines";
import { classificationType } from "./Form";
import moment from "moment";

const getName = (val) => {
  return classificationType?.find((r) => r?.value === val)?.label;
};
const List = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col ">
      <div className="flex items-center justify-between w-full h-20 py-3 px-8">
        <div className="text-xl font-semibold leading-5 text-black ">
          {t("type.type")}
        </div>
        <Link
          to={`new`}
          className="p-2 border-2 rounded hover:cursor-pointer border-primary"
        >
          <IoMdAdd color="#1A2E55" />
        </Link>
      </div>
      <div className="px-4">
        <Table
          url={`/type/table`}
          sort={{ _id: -1 }}
          columns={[
            {
              label: t("type.classification"),
              key: `classification`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ _id, classification }) => {
                return <div className="">{getName(classification)}</div>;
              },
            },
            {
              label: t("type.type"),
              key: `type`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ _id, type }) => {
                return (
                  <Link to={`view/${_id}`}>
                    <div className="text-primary underline font-semibold">
                      {type}
                    </div>
                  </Link>
                );
              },
            },
            {
              label: t("createdby"),
              key: `createdby.email`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("created"),
              key: `created`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ created }) =>
                moment(created).format("YYYY-MM-DD HH:mm:ss"),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default List;
